<template>
  <div>
    <b-container fluid class="mr-0">
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBarMember class="mb-0 mb-sm-3" />
        </b-col>
      </b-row>
    </b-container>
    <b-container class="px-0 px-sm-3 overflow-hidden">
      <b-card
        header-bg-variant="dark"
        header-border-variant="dark"
        header-text-variant="white"
        header-tag="header"
        body-bg-variant="light"
        border-variant="dark"
        class="main-card"
        body-class="p-1 p-sm-3"
      >
        <template #header class="card-header px-0">
          <router-link to="/">
            <i class="fas fa-chevron-left"></i> หน้าหลัก
          </router-link>
        </template>
        <b-row class="mb-2">
          <b-col>
            <b-card
              body-class="p-2 d-flex flex-column flex-sm-column flex-md-row justify-content-between"
              class="shadow-sm"
              border-variant="white"
            >
              <h5 class="mb-0 mt-1">
                <i class="fas fa-info-circle"></i> วิธีการใช้งาน
              </h5>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <b-card
              body-class="rounded-lg"
              class="shadow-sm"
              body-bg-variant="dark"
              body-text-variant="light"
              border-variant="white"
            >
              <h4 class="mb-0 mt-1 font-weight-bold">วิธีสมัครสมาชิก</h4>
              <ol>
                <li>สมัครสมาชิกที่: <a :href="getSiteUrl + '/register/step-1'" target="_blank">{{getSiteUrl}}/register/step-1</a></li>
                <li>ใส่เบอร์โทรศัพท์ กดปุ่มไม่ใช่บอท</li>
                <li>กรอกชื่อผู้ใช้เป็น "ตัวเลขหรือภาษาอังกฤษ อย่างน้อย 6 ตัว"</li>
                <li>กรอกรหัสผ่านเหมือนข้อ 4. อีกครั้ง เพื่อยืนยันรหัสผ่าน</li>
                <li>
                  กด <strong>"+ เพิ่มบัญชีธนาคาร"</strong>
                  <ul>
                    <li>เลือก <strong>"ธนาคารของท่าน"</strong></li>
                    <li>ระบุเลขบัญชีเฉพาะตัวเลข</li>
                    <li>ยืนยันเลขบัญชีเหมือนกับที่ระบุไปก่อนหน้าอีกครั้งเพื่อยืนยัน</li>
                    <li>ระบุชื่อ นามสกุล หน้าสมุดบัญชี</li>
                  </ul>
                </li>
                <li>สามารถตั้งค่า หรือ เปลี่ยนรหัสผ่าน บัญชีของท่านได้ที่เมนูด้านบน <strong>"ตั้งค่าบัญชีผู้ใช้"</strong></li>
              </ol>
              <h4 class="mb-0 mt-1 font-weight-bold">วิธีเติมเงิน</h4>
              <p class="mb-0">สามารถเติมเงินได้หลังจากระบบอนุมัติผ่าน บัญชีของท่านเเล้ว</p>
              <ol>
                <li><a :href="getSiteUrl + '/member/deposit'" target="_blank">{{getSiteUrl}}/member/deposit</a></li>
                <li>เลือกธนาคารปลายทางที่ท่านต้องการเติมเงิน</li>
                <li>
                  ท่านต้องโอนเงินให้เสร็จสิ้นด้วยตัวท่านเองผ่านช่องท่างที่ท่านต้องการเสียก่อน
                  <ul>
                    <li>โอนเงินขั้นต่ำครั้งละ 20 บาท</li>
                    <li>ถ้าโอนต่ำกว่า 20 บาท เงินของท่านจะไม่เข้าระบบเเละไม่สามารถคืนได้</li>
                    <li>กรุณาใช้บัญชีที่ท่านผู้กกับ {{getAppName}} ในการโอนเงินเท่านั้น</li>
                    <li>เก็บสลิปการโอนเงินไว้ทุกครั้งเมื่อท่านทำการโอนเสร็จสิ้นเเล้ว</li>
                  </ul>
                </li>
                <li>
                  เมื่อโอนเงินเเล้ว ให้ระบุข้อมูลการโอนเงินของท่าน
                  <ul>
                    <li>เลือกธนาคารของท่านที่ลงทะเบียนกับ {{getAppName}}</li>
                    <li>เลือกช่องทางการโอนเงินของท่าน</li>
                    <li>ใส่จำนวนเงินที่โอนเข้ามาตามสลิปของท่าน</li>
                    <li>เลือก <strong>"วัน/เดือน/ปี"</strong> ที่ท่านโอนเงินเข้ามาตามสลิปโอนเงิน</li>
                    <li>เลือก <strong>"เวลา"</strong> ที่ท่านโอนเงินเข้ามาตามสลิปโอนเงิน</li>
                  </ul>
                </li>
                <li>กด <strong>"ยืนยันการเเจ้งโอนเงิน"</strong> เเละ รอระบบประมวณผลไม่เกิน 5 นาที</li>
                <li>ท่านสามารถตรวจสอบยอดเงินของท่านได้ที่เมนูเครดิตด้านบนหรือหน้าหลัก {{getAppName}}</li>
                <li>สามารถเพิ่มบัญชีธนาคารอื่น เพิ่มเติมได้ที่เมนูด้านบน <strong>"บัญชีธนาคาร"</strong></li>
                <li>สามารถเช็ครายการฝาก/ถอนทั้งหมดในบัญชีของท่านได้ที่เมนู <strong>"รายการเเจ้งฝาก/ถอน"</strong></li>
              </ol>
              <h4 class="mb-0 mt-1 font-weight-bold">วิธีถอนเงิน</h4>
              <p class="mb-0">สามารถถอนเงินได้หลังจากระบบอนุมัติผ่าน บัญชีของท่านเเล้ว</p>
              <ol>
                <li><a :href="getSiteUrl + '/member/withdraw'" target="_blank">{{getSiteUrl}}/member/withdraw</a></li>
                <li>
                  ระบุจำนวนเงินที่ท่านต้องการจะถอน หรือ กดทั้งหมด เพื่อถอนเงินออกทั้งหมด
                  <ul>
                    <li>ถอนเงินขั้นต่ำ 100 หรือ สูงสุด 200,000 บาท</li>
                  </ul>
                </li>
                <li>กด <strong>"ถอนเงิน"</strong> ระบบจะทำการประมวณผลยอดเงินที่ท่านต้องการเงินออก</li>
                <li>เงินที่ท่านกด <strong>"ถอนเงิน"</strong> ออกจากถูกโอนเข้าบัญชีที่ลงทะเบียนกับ {{getAppName}} ไว้อัตโนมัติ</li>
                <li>สามารถเพิ่มบัญชีธนาคารอื่น เพิ่มเติมได้ที่เมนูด้านบน <strong>"บัญชีธนาคาร"</strong></li>
                <li>สามารถเช็ครายการฝาก/ถอนทั้งหมดในบัญชีของท่านได้ที่เมนู <strong>"รายการเเจ้งฝาก/ถอน"</strong></li>
              </ol>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
    <FooterIndex class="mt-3" />
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import axios from "axios";

// Include Component
import TopBarMember from "@/components/TopBarMember.vue";
import Result from "@/components/member/jackpot/Result.vue";
import Poy from "@/components/member/jackpot/Poy.vue";
// import Tang from "@/components/member/lotteryset/hanoi/Tang.vue";
import Tang from "@/components/member/jackpot/Tang2.vue";
import FooterIndex from "@/components/Footer.vue";

export default {
  name: 'Jackpot',
  props: ['page'],
  components: {
    TopBarMember,
    Result,
    Poy,
    Tang,
    FooterIndex
  },
  data() {
    return {
      filter: "TODAY",
      transactions: [],
      transactionTypes: [
        {
          code: "BET",
          title: "แทงพนัน"
        }
      ],
      paymentMethods: [
        {
          code: "ATM",
          title: "ATM",
          description: "โอนจากตู้กดเงินสด"
        },
        {
          code: "CDM",
          title: "CDM",
          description: "ฝากผ่านตู้ฝากเงินสด"
        },
        {
          code: "CTC",
          title: "Counter Cashier",
          description: "ฝากเงินผ่านเคาน์เตอร์ธนาคาร"
        },
        {
          code: "INB",
          title: "Internet Banking",
          description: "โอนเงินผ่านหน้าเว็บไซต์"
        },
        {
          code: "MBB",
          title: "Mobile Banking",
          description: "โอนเงินผ่านแอพมือถือ"
        }
      ],
      lottoInfo: {},
      lottoType: 29
    };
  },
  mounted() {
    this.getLottoInfo();
  },   
  methods: {
    getLottoInfo() {
      axios.post(this.getApiUrl + "/jackpot/available",
          {
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername
            }
          }
        )
        .then(response => {
          this.lottoInfo = response.data.data;
          console.log("getLottoInfo",this.lottoInfo);
        });
    } 
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getLottoType: "getLottoType",
      getApiUrl: "getApiUrl",
      getAppName: "getAppName",
      getSiteUrl: "getSiteUrl"
    })
  }   
}
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

.bg-gold {
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  ) !important;
  border: 1px solid #a55d07;
  text-shadow: rgb(0 0 0) 2px 0px 0px, rgb(0 0 0) 1.75517px 0.958851px 0px,
    rgb(0 0 0) 1.0806px 1.68294px 0px, rgb(0 0 0) 0.141474px 1.99499px 0px,
    rgb(0 0 0) -0.832294px 1.81859px 0px, rgb(0 0 0) -1.60229px 1.19694px 0px,
    rgb(0 0 0) -1.97998px 0.28224px 0px, rgb(0 0 0) -1.87291px -0.701566px 0px,
    rgb(0 0 0) -1.30729px -1.5136px 0px, rgb(0 0 0) -0.421592px -1.95506px 0px,
    rgb(0 0 0) 0.567324px -1.91785px 0px, rgb(0 0 0) 1.41734px -1.41108px 0px,
    rgb(0 0 0) 1.92034px -0.558831px 0px;
  font-weight: normal !important;
}

.font-mitr {
  font-family: "Mitr", sans-serif;
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.btn {
  i {
    font-size: 25px;
  }

  &-warning {
    background-color: #bd841b;
    border-color: #bd841b;
    color: #ffffff;
  }

  &-outline-warning {
    color: #bd841b;
    border-color: #bd841b;
  }

  &:hover,
  &:focus,
  &:active {
    background-color: #bd841b;
    border-color: #bd841b;
    outline: none;
    box-shadow: none;
    color: #ffffff;
  }
}
</style>